import React from "react";
import { Switch, Route } from "react-router-dom";
import { Redirect } from "react-router-dom";
import Landing from "./Public/Home/Landing";
import UserHome from "./Public/Home/UserHome";
import Catalog from "./Public/Catalog";
import Publication from "./Publication/Publication";
import FAQ from "./Public/FAQ";
import Guide from "./Public/Guide";
import Terms from "./Public/Terms";
import Login from "./Auth/Login";
import CreatePassword from "./Auth/CreatePassword";
import ForgotPassword from "./Auth/ForgotPassword";
import Register from "./Auth/Register";
import SyncAccount from "./Auth/SyncAccount";
import Logout from "./Auth/Logout";
import CourseCatalog from "./Course/Catalog";
import FormProfile from "./User/FormProfile";
import Profile from "./User/Profile";
import TransactionList from "./Transaction/List";
import TransactionDetail from "./Transaction/Detail";
import CourseDetail from "./Course/Detail";
import CourseOrderConfirmation from "./Course/OrderConfirmation/OrderConfirmation";
import EventCatalog from "./Event/Catalog";
import EventDetail from "./Event/Detail";
import EventOrder from "./Event/Order";
import EventOrderConfirmation from "./Event/OrderConfirmation";
import EventTicket from "./Event/Ticket";
import CourseCoupon from "./Course/Coupon";
import QuizAttempt from "./Quiz/Attempt";
import QuizResult from "./Quiz/Result";
import CourseRecap from "./Course/Recap";
import CourseCertificate from "./Course/Certificate";
import Certificate from "./Public/Certificate";
import LPCertificate from "./Public/LPCertificate";
import Search from "./Public/Search";
import LearningPathCatalog from "./LearningPath/Catalog";
import LearningPathDetail from "./LearningPath/Detail";
import LearningPathDetailLearn from "./LearningPath/DetailLearn";
import LearningPathCertificate from "./LearningPath/Certificate";
import LearningPathOrder from "./LearningPath/Order/Order";
import CommunityCatalog from "./Community/Catalog";
import CommunityDetail from "./Community/Detail";
import CommunityRegister from "./Community/Register";
import HelpForm from "./Help/Form";
import HelpList from "./Help/List";
import Odoa from "./SpecialEvents/Odoa";
import Payment from "./Payment/Payment";
import MentorList from "./Mentor/MentorList";
import { CheckAuth } from "./Util";
import ResetPassword from "./Auth/ResetPassword";
import Contacts from "./Contacts/Contacts";
import UserLanding from "./Public/Home/UserLanding";
import { QuizRecap } from "./Quiz/Recap";

// The Main component renders one of the three provided
// Routes (provided that one matches). Both the /roster
// and /schedule routes will match any pathname that starts
// with /roster or /schedule. The / route will only match
// when the pathname is exactly the string "/"

function PrivateRoute({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        CheckAuth() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location },
              search: "?redirect=" + rest.location.pathname,
            }}
          />
        )
      }
    />
  );
}

const Main = (props) => (
  <main>
    <Switch>
      <Route
        exact
        path="/"
        render={() => (
          <Redirect
            to={{
              pathname: "/course/catalog",
            }}
          />
        )}
      />
      <PrivateRoute path="/home" component={UserLanding} />
      <Route path="/account/sync" component={SyncAccount} />
      <Route path="/search" component={Search} />
      <Route path="/catalog" component={Catalog} />
      <Route path="/publication" component={Publication} />
      <Route path="/register" component={Register} />
      <Route path="/login" component={Login} />
      <Route path="/create-password" component={CreatePassword} />
      <Route path="/forgot-password" component={ForgotPassword} />
      <Route path="/reset-password" component={ResetPassword} />
      {/* <Route path='/register' component={() => { window.location = '/login'} } /> */}
      <Route path="/logout" component={Logout} />
      <Route path="/faq" component={FAQ} />
      <Route path="/guide" component={Guide} />
      <Route path="/terms" component={Terms} />
      <PrivateRoute path="/profile/edit" component={FormProfile} />
      <PrivateRoute path="/profile" component={Profile} />
      <PrivateRoute
        path="/transactions/:invoice_number"
        component={TransactionDetail}
      />
      <PrivateRoute path="/transactions" component={TransactionList} />
      <Route path="/certificate/:uuid" component={Certificate} />
      <Route path="/lp-certificate/:uuid" component={LPCertificate} />
      <Route path="/coupon/:uuid" component={CourseCoupon} />
      <Route path="/course/catalog/" component={CourseCatalog} />
      <PrivateRoute
        path="/course/invoice/:invoice_number"
        component={CourseOrderConfirmation}
      />
      <Route path="/course/:uuid/recap" component={CourseRecap} />
      <Route path="/course/:uuid/certificate" component={CourseCertificate} />
      <Route path="/course/:uuid/:enroll?" component={CourseDetail} />
      <Route path="/event/catalog" component={EventCatalog} />
      <PrivateRoute
        path="/event/:uuid/order/success"
        component={EventOrderConfirmation}
      />
      <PrivateRoute path="/event/:uuid/order" component={EventOrder} />
      <PrivateRoute path="/event/:uuid/ticket" component={EventTicket} />
      <Route path="/event/:uuid/:buy?" component={EventDetail} />
      <PrivateRoute path="/quiz/result/:uuid/recap" component={QuizRecap} />
      <PrivateRoute path="/quiz/result/:uuid" component={QuizResult} />
      <PrivateRoute path="/quiz/:uuid" component={QuizAttempt} />
      <Route path="/learning-path/catalog" component={LearningPathCatalog} />
      <Route
        path="/learning-path/:uuid/certificate"
        component={LearningPathCertificate}
      />
      <Route path="/learning-path/:uuid/order" component={LearningPathOrder} />
      <Route
        path="/learning-path/:uuid/learn"
        component={LearningPathDetailLearn}
      />
      <Route path="/learning-path/:uuid" component={LearningPathDetail} />
      <Route path="/community/catalog" component={CommunityCatalog} />
      <PrivateRoute path="/community/register" component={CommunityRegister} />
      <Route path="/community/:uuid" component={CommunityDetail} />
      <Route path="/help/form" component={HelpForm} />
      <Route path="/help" render={() => <HelpList {...props} />} />
      <Route path="/odoa" component={Odoa} />
      <Route path="/payment" component={Payment} />
      <Route
        path="/surveypromo517"
        component={() => {
          window.location = "https://www.surveymonkey.com/r/SurveyPromo517";
        }}
      />
      <Route path="/mentor/:token" component={MentorList} />
      <Route path="/contacts" component={Contacts} />
    </Switch>
  </main>
);

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js